export class UpdateOrganizationIdpGroupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "OrganizationIdpGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateOrganizationIdpGroupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
